import { toast } from "react-hot-toast";

// Simple toast implementation as a placeholder for functionality
export const SuccessToast = (message: string) => {
  toast.success(message);
};

export const ErrorToast = (message: string) => {
  toast.error(message);
};
